export default {
  popups: {
    info: {
      noAccessToDefaultView: 'Accès refusé à la vue par défaut. Redirection vers la vue par défaut de votre rôle.',
      notSelectedRoleDefaultView: 'Pas de vue par défaut sélectionnée pour votre rôle.',
      noAccessToRoleDefaultView: 'Accès refusé à la vue par défaut de votre rôle.',
    },
  },
};
